import Switch from "@mui/material/Switch";

import { styled, Theme } from "@mui/material/styles";
import colors from "../../assets/theme/base/colors";

export default styled(Switch)(({ theme, ownerState }: { theme?: Theme; ownerState: any }) => {
    const { gradients } = colors;

    const { palette, functions } = theme!;
    const { rgba } = functions;
    const { checkedColor, disabled, checked } = ownerState;
    const { transparent } = palette;

    const getCheckedColor = () => {
        if (checked === true && disabled === true) return 0.6;
        if (checked === false && disabled === true) return 0.3;
        if (checked === false && disabled === false) return 0.6;
        return 1;
    };
    const getDisabledColor = () => {
        if (checked === true && disabled === true) return 0.5;
        if (checked === false && disabled === true) return 0.2;
        return 0.1;
    };

    const defaultStyles = () => ({
        ".MuiSwitch-switchBase": {
            "&.MuiButtonBase-root": {
                "& + .MuiSwitch-track": {
                    backgroundColor: rgba(gradients[checkedColor].main, getCheckedColor()),
                    opacity: 1,
                },
            },
            "&.Mui-checked": {
                color: "#fff",
                "&:hover": {
                    backgroundColor: transparent.main,
                },
                "& + .MuiSwitch-track": {
                    backgroundColor: rgba(gradients[checkedColor].main, getCheckedColor()),
                    opacity: 1,
                },
            },
            "&.Mui-checked.Mui-disabled": {
                color: "#fff",
            },
            "&.Mui-disabled": {
                "& + .MuiSwitch-track": {
                    backgroundColor: rgba(gradients["secondary"].main, getDisabledColor()),
                    opacity: 1,
                },
            },
        },
    });

    const android12Switch = () => ({
        padding: 8,
        "& .MuiSwitch-track": {
            borderRadius: 22 / 2,
            "&:before, &:after": {
                content: '""',
                top: "50%",
                width: 16,
                height: 16,
                position: "absolute",
                transform: "translateY(-50%)",
            },
            // '&:before': {
            //     backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
            //         theme.palette.getContrastText(theme.palette.primary.main),
            //     )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            //     left: 12,
            // },
            // '&:after': {
            //     backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
            //         theme.palette.getContrastText(theme.palette.primary.main),
            //     )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            //     right: 12,
            // },
        },
        "& .MuiSwitch-thumb": {
            boxShadow: "none",
            width: 16,
            height: 16,
            margin: 2,
        },
    });

    return {
        backgroundColor: transparent.main,
        ...defaultStyles(),
        ...android12Switch(),
    };
});
